const usd0 = new Intl.NumberFormat('es-UY', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 })
const num = new Intl.NumberFormat('es-UY', { maximumFractionDigits: 2 })

export const usd = (n?: number | null) => {
  if (n == null || isNaN(n) || !isFinite(n)) return '—'
  const s = `USD ${usd0.format(Math.abs(n)).replace(/[^\d.,]/g, '')}`
  return n < 0 ? `−${s}` : s
}
export const fmtNum = (n?: number | null, d = 2) => (n == null || !isFinite(n) ? '—' : new Intl.NumberFormat('es-UY', { maximumFractionDigits: d }).format(n))
export const pct = (n?: number | null, d = 1) => (n == null || !isFinite(n) ? '—' : `${new Intl.NumberFormat('es-UY', { maximumFractionDigits: d, minimumFractionDigits: d }).format(n * 100)} %`)
export { num }

const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
const DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado']
export const MESES_CORTOS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']
export const DIAS_CORTOS = ['lun', 'mar', 'mié', 'jue', 'vie', 'sáb', 'dom']
export { MESES, DIAS }

/** "2026-10-15" → Date local (sin corrimiento de zona horaria) */
export const parseDay = (s: string) => { const [y, m, d] = s.slice(0, 10).split('-').map(Number); return new Date(y, m - 1, d) }
export const ymd = (d: Date) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
export const today = () => ymd(new Date())

export const fmtDay = (s?: string) => {
  if (!s) return '—'
  const d = parseDay(s)
  return `${d.getDate()} ${MESES_CORTOS[d.getMonth()]}`
}
export const fmtDayLong = (s?: string) => {
  if (!s) return '—'
  const d = s.length > 10 ? new Date(s) : parseDay(s)
  return `${DIAS[d.getDay()]} ${d.getDate()} de ${MESES[d.getMonth()]}`
}
export const fmtTime = (iso?: string) => {
  if (!iso) return ''
  const d = new Date(iso)
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`
}

/** Convierte valor de <input type="datetime-local"> a ISO con zona horaria local */
export function localToIso(v: string) {
  if (!v) return ''
  const d = new Date(v)
  const tz = -d.getTimezoneOffset(), sign = tz >= 0 ? '+' : '-', p = (n: number) => String(Math.abs(n)).padStart(2, '0')
  return `${v.length === 16 ? v + ':00' : v}${sign}${p(Math.trunc(tz / 60))}:${p(tz % 60)}`
}
export function isoToLocal(iso?: string) {
  if (!iso) return ''
  const d = new Date(iso)
  return `${ymd(d)}T${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`
}

export const relTime = (ts: number) => {
  if (!ts) return 'sin sincronizar'
  const s = Math.round((Date.now() - ts) / 1000)
  if (s < 10) return 'recién'
  if (s < 60) return `hace ${s} s`
  return `hace ${Math.round(s / 60)} min`
}

export const mapsLink = (p?: Record<string, any>) =>
  p?.mapa || (p?.direccion ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent([p.direccion, p.ciudad, 'Uruguay'].filter(Boolean).join(', '))}` : '')

export const waNumber = (s?: string) => String(s ?? '').replace(/[^\d]/g, '')
